export default function PorQueNoSolo() {
  const comparaciones = [
    {
      aspecto: 'Tasa de aprobación',
      porTuCuenta: '60% aprobación',
      conAbogado: '100% aprobación',
      iconoNegativo: 'ri-close-circle-fill',
      iconoPositivo: 'ri-checkbox-circle-fill'
    },
    {
      aspecto: 'Tiempo de resolución',
      porTuCuenta: '3-6 meses',
      conAbogado: '20 días laborables',
      iconoNegativo: 'ri-time-line',
      iconoPositivo: 'ri-flashlight-fill'
    },
    {
      aspecto: 'Nivel de estrés',
      porTuCuenta: 'Estrés máximo',
      conAbogado: 'Proceso guiado',
      iconoNegativo: 'ri-emotion-unhappy-line',
      iconoPositivo: 'ri-emotion-happy-line'
    },
    {
      aspecto: 'Riesgo de rechazo',
      porTuCuenta: 'Riesgo alto (40%)',
      conAbogado: 'Garantía de éxito',
      iconoNegativo: 'ri-alert-fill',
      iconoPositivo: 'ri-shield-check-fill'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="w-20 h-20 flex items-center justify-center bg-red-600 rounded-full mx-auto mb-6">
              <i className="ri-error-warning-fill text-4xl text-white"></i>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              ¿Por qué no hacerlo solo?
            </h2>
            <p className="text-xl text-gray-700">
              La diferencia entre intentarlo por tu cuenta y tener un experto a tu lado
            </p>
          </div>

          {/* Tabla para desktop */}
          <div className="hidden lg:block bg-white rounded-2xl shadow-2xl overflow-hidden mb-12">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-gray-800 to-gray-900">
                    <th className="py-6 px-6 text-left text-white font-bold text-lg">Aspecto</th>
                    <th className="py-6 px-6 text-center text-white font-bold text-lg">
                      <div className="flex flex-col items-center">
                        <i className="ri-user-line text-3xl mb-2"></i>
                        <span>Por tu cuenta</span>
                      </div>
                    </th>
                    <th className="py-6 px-6 text-center text-white font-bold text-lg">
                      <div className="flex flex-col items-center">
                        <i className="ri-shield-star-fill text-3xl mb-2"></i>
                        <span>Con Abogado Lino García</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {comparaciones.map((item, index) => (
                    <tr 
                      key={index}
                      className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-blue-50 transition-colors`}
                    >
                      <td className="py-6 px-6 font-semibold text-gray-900 text-lg">
                        {item.aspecto}
                      </td>
                      <td className="py-6 px-6 text-center">
                        <div className="flex flex-col items-center gap-2">
                          <i className={`${item.iconoNegativo} text-3xl text-red-600`}></i>
                          <span className="text-gray-700 font-medium">{item.porTuCuenta}</span>
                        </div>
                      </td>
                      <td className="py-6 px-6 text-center">
                        <div className="flex flex-col items-center gap-2">
                          <i className={`${item.iconoPositivo} text-3xl text-green-600`}></i>
                          <span className="text-gray-900 font-bold">{item.conAbogado}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Tarjetas para móvil */}
          <div className="lg:hidden space-y-6 mb-12">
            {comparaciones.map((item, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-gray-800 to-gray-900 py-4 px-6">
                  <h3 className="text-xl font-bold text-white text-center">
                    {item.aspecto}
                  </h3>
                </div>
                
                <div className="p-6 space-y-6">
                  {/* Por tu cuenta */}
                  <div className="bg-red-50 rounded-lg p-4 border-2 border-red-200">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-full flex-shrink-0">
                        <i className="ri-user-line text-xl text-red-600"></i>
                      </div>
                      <span className="font-bold text-gray-900">Por tu cuenta</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <i className={`${item.iconoNegativo} text-3xl text-red-600 flex-shrink-0`}></i>
                      <span className="text-gray-700 font-medium">{item.porTuCuenta}</span>
                    </div>
                  </div>

                  {/* Con Abogado */}
                  <div className="bg-green-50 rounded-lg p-4 border-2 border-green-200">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                        <i className="ri-shield-star-fill text-xl text-green-600"></i>
                      </div>
                      <span className="font-bold text-gray-900">Con Abogado Lino García</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <i className={`${item.iconoPositivo} text-3xl text-green-600 flex-shrink-0`}></i>
                      <span className="text-gray-900 font-bold">{item.conAbogado}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Banner final */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-xl p-8 lg:p-12 text-center text-white">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-shield-check-fill text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl lg:text-4xl font-bold mb-4">
              No arriesgues tu futuro en España
            </h3>
            <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
              Un rechazo puede significar meses de espera adicional y pérdida de oportunidades. Deja que nuestro equipo especializado garantice tu éxito desde el primer intento.
            </p>
            <a 
              href="#consulta" 
              className="inline-block bg-white text-blue-600 px-10 py-4 rounded-xl font-bold text-lg hover:bg-blue-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Solicitar Asesoría Profesional
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
